<template>
<div>

	<!-- Begin Title Bar -->
	<v-toolbar tile elevation="2">
		<v-toolbar-title>
			<span v-if="orderType === 'received'">
				{{ $t('nav.ordersForMe') }}
			</span>
			<span v-else-if="orderType === 'sent'">
				{{ $t('nav.myOrders') }}
			</span>
			<span v-else>
			</span>
		</v-toolbar-title>

		<v-spacer></v-spacer>

		<v-btn icon v-if="initializationDone" @click="$router.go(-1)">
			<v-icon class="color-green">mdi-arrow-left</v-icon>
		</v-btn>
		<v-btn icon v-if="initializationDone" @click="refresh">
			<v-icon class="color-green">mdi-refresh</v-icon>
		</v-btn>
		<v-btn icon v-if="initializationDone" @click="showHelp = true">
			<v-icon class="color-green">mdi-help-circle</v-icon>
		</v-btn>
	</v-toolbar>
	<!-- End Title Bar -->

	<!-- begin orders for me help -->
<!--   <OrdersForMeHelp v-if="orderType === 'received'" id="orders-for-me-top-help"
		showfirst style="margin-top: -10px">
	</OrdersForMeHelp> -->
	<!-- end orders for me help -->

	<Preloader v-if="!initializationDone" :text="$t('common.phrase.loading')"></Preloader>

	<v-container v-if="initializationDone">

		<v-sheet elevation="2" class="pa-5 my-4">

			<div v-if="orderList.length > 0">

				<div v-for="order of orderList" :key="'order' + '-' + order.orderHash">

					<OrderSummary v-if="orderType === 'received'"
						initialorderstatechecking
						showfillorder
						:key="'orderSummary' + '-' + order.orderHash"
						:parsedOrder="order"
						:myaddress="myAddress"
						:myaccount="account"
						:accounturl="networkConfig.accountURL"
						:tokenurl="networkConfig.tokenURL"
						v-on:delete-order-complete="init()"
					>
					</OrderSummary>

					<OrderSummary v-if="orderType === 'sent'"
						showorderlink showdeletelink
						initialorderstatechecking
						:key="'orderSummary' + '-' + order.orderHash"
						:parsedOrder="order"
						:myaddress="myAddress"
						:myaccount="account"
						:accounturl="networkConfig.accountURL"
						:tokenurl="networkConfig.tokenURL"
						v-on:delete-order-complete="init()"
					>
					</OrderSummary>

				</div>

			</div>

			<div v-else class="my-4 pa-5 text-center">
				<div class="mb-3">{{ $t('common.phrase.noOrderFound') }}</div>
				<div class="m-3" v-if="orderType === 'sent'">
					<BackButton></BackButton> &nbsp;
					<v-btn variant="success" :to="{ name: 'NewOrder' }">{{ $t('nav.createNewOrder') }}</v-btn>
				</div>
				<div v-else>
					<BackButton></BackButton>
				</div>
			</div>

		</v-sheet>


		<!-- Begin Help -->
		<v-bottom-sheet v-model="showHelp">

			<v-card tile>

				<!--Modal Title -->
				<v-toolbar flat v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }">
					<v-toolbar-title><v-icon>mdi-help-circle</v-icon> {{ $t('nav.help') }}</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon @click="showHelp = false">
						<v-icon>mdi-window-close</v-icon>
					</v-btn>
				</v-toolbar>

				<!-- Modal Contents -->
				<v-card-text v-if="orderType === 'sent'" class="py-5 px-3" style="max-height: 400px; overflow-y: scroll;">
					<MyOrdersHelp class="mb-2"></MyOrdersHelp>
				</v-card-text>

				<v-card-text v-if="orderType === 'received'" class="py-5 px-3" style="max-height: 400px; overflow-y: scroll;">
					<OrdersForMeHelp class="mb-2"></OrdersForMeHelp>
				</v-card-text>

			</v-card>

    </v-bottom-sheet>
    <!-- End Help -->

	</v-container>

</div>
</template>

<script>

import {mapActions, mapGetters, mapState} from 'vuex'
import OrderSummary from "@/components/OrderSummary"
import Preloader from "@/components/Preloader"
import BackButton from "@/components/BackButton"
import MyOrdersHelp from "@/components/help/MyOrdersHelp"
import OrdersForMeHelp from "@/components/help/OrdersForMeHelp"
import { getAssetAddressFromAssetData, getCurrentGasPrice } from '@/utils/utils'
import { HttpClient } from '@0x/connect'

export default {
	name: 'MyOrders',
	components: {
		OrderSummary,
		Preloader,
		BackButton,
		MyOrdersHelp,
		OrdersForMeHelp
	},
	data () {
		return {
			orderList: [],
			initializationDone: false,
			showHelp: false,
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			tokenInfo: 'getTokenInfo',
			myAddress: 'getUserAccount',
			networkConfig: 'getNetworkConfig',
		}),
		orderType: function () {
			return this.$route.params.orderType ? this.$route.params.orderType : 'sent'
		},
		searchOptions: function () {
			if (this.orderType === 'received') {
				return {
					takerAddress: this.network.userAccount
				}
			}
			else if (this.orderType === 'sent') {
				return {
					makerAddress: this.network.userAccount
				}
			}
			else {
				throw new Error ('Unknown order type')
			}
		}
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount', 'parseSignedOrder']),

		/* ------------------------------------------------------ */
		async init () {
			this.initializationDone = false
			this.orderList = []
			await this.loadNetwork()
			await this.loadTokenInfo()
			await this.loadAccount()
			await this.loadMyOrders()
			await getCurrentGasPrice(this.network.id)
			// console.log(this.orderList)
			this.initializationDone = true
		},

		async refresh () {
			this.init();
		},

		async loadMyOrders () {
			// console.log('loadMyOrders, ', this.apiURL)
			const httpClient = new HttpClient(this.networkConfig.backendSRAHttpURL)
			let apiResult = null
			try {
				apiResult = await httpClient.getOrdersAsync({
					...this.searchOptions
				})
				console.log(apiResult)
				for (let record of apiResult.records) {
					const order = record.order
					try {
						const parsedOrder = await this.parseSignedOrder(order)
						this.orderList.push(parsedOrder)
					} catch (err) {
						console.log(err)
						continue
					}
				}
			} catch (err) {
				console.log(err)
				this.$emit("errorNotification", this.$t('common.err.generic'))
				// console.log(relayer.name + ' Error: ' + err.toString())
			}
		},

		showOrderJson (order) {
			order.showJson = true
		},

		hideOrderJson (order) {
			order.showJson = false
		}

	},
	created () {
		this.init()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
